import { Injectable, OnDestroy } from '@angular/core';
import { Button } from '../../../app/flow/models/flow.model';
import { ButtonPosition } from "../../common/models/flow.dto";
import { FlowComponent } from '../components/flow/flow.component';

@Injectable()
export class FlowButtonOverrideService implements OnDestroy {
    public _flow: FlowComponent
    public _originalFunc: (button: Button) => any;
    public _prevButtonNextValidator: (button: Button) => boolean;
    public _incrementStep: (button: Button) => void;
    public _decrementStep: (button: Button) => void;

    set flow(value: FlowComponent) {
        if (this._flow) {
            this.resetOverride();
        }           
        this._flow = value;
        if (this._flow) {
            this._originalFunc = this._flow.buttonClick;
            this._flow.buttonClick = this._buttonClick.bind(this);
        }
    }

    get flow() {
        return this._flow;
    }

    set incrementFunction(func: (button: Button) => void) {
        this._incrementStep = func;
    }

    set decrementFunction(func: (button: Button) => void) {
        this._decrementStep = func;
    }

    constructor() {
    }

    resetOverride(): void {
        if (this._flow) {
            this._flow.showNavigationButtons = true;
            this._incrementStep = null;
            this._decrementStep = null;
            this.removeValidatorNextButton();
        }
    }

    setValidatorNextButton(func: (button: Button) => boolean): void {
        if (this._flow) {
            if (!this._prevButtonNextValidator)
                this._prevButtonNextValidator = this._flow.isButtonDisabled;

            this._flow.isButtonDisabled = func;
        }        
    }

    removeValidatorNextButton(): void {
        if (this._prevButtonNextValidator && this._flow) {
            this._flow.isButtonDisabled = this._prevButtonNextValidator;
            this._prevButtonNextValidator = null;
        }
    }

    hideNavigationButtons(): void {
        this._flow.showNavigationButtons = false;
    }

    showNavigationButtons(): void {
        this._flow.showNavigationButtons = true;
    }

    callOriginalFunction(button: Button) {
        this._originalFunc.bind(this._flow)(button);
        this.resetOverride();
    }

    ngOnDestroy(): void {
        if (this._flow) {
            this._flow.buttonClick = this._originalFunc;
            this._flow.showNavigationButtons = true;
        }
        this._incrementStep = null;
        this._decrementStep = null;
        this.removeValidatorNextButton();
    }

    public _buttonClick(button: Button): void {
        if (this._incrementStep && (button.isNext || button.isPageJump && button.position === ButtonPosition.Right))
            this._incrementStep(button);
        else if (this._decrementStep && (button.isBack || button.isPageJump && button.position === ButtonPosition.Left))
            this._decrementStep(button);
        else
            this.callOriginalFunction(button);
    }
}
